import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QrCode, Download, Printer } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

interface Props {
  id: string;
  name: string;
  type: "child" | "staff";
  role?: string;
  trigger?: React.ReactNode;
}

export default function QRCardGenerator({ id, name, type, role, trigger }: Props) {
  const [open, setOpen] = useState(false);

  const handlePrint = () => {
    const printContent = document.getElementById(`qr-card-${id}`);
    if (!printContent) return;

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <html dir="rtl">
        <head>
          <title>بطاقة ${name}</title>
          <style>
            body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; min-height: 100vh; margin: 0; }
            .card { border: 2px solid #e5e7eb; border-radius: 16px; padding: 24px; text-align: center; width: 300px; }
            .name { font-size: 18px; font-weight: bold; margin: 12px 0 4px; }
            .type { font-size: 12px; color: #6b7280; }
            .id { font-size: 9px; color: #9ca3af; margin-top: 8px; word-break: break-all; }
          </style>
        </head>
        <body>
          <div class="card">
            ${printContent.innerHTML}
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="icon" title="بطاقة QR">
            <QrCode className="w-4 h-4" />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-xs" dir="rtl">
        <DialogHeader>
          <DialogTitle>بطاقة QR - {name}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center py-4" id={`qr-card-${id}`}>
          <QRCodeSVG
            value={id}
            size={200}
            level="H"
            includeMargin
            bgColor="transparent"
          />
          <p className="name text-lg font-bold text-foreground mt-3">{name}</p>
          <p className="type text-xs text-muted-foreground">
            {type === "child" ? "طفل/ة" : role || "موظف/ة"}
          </p>
          <p className="id text-[9px] text-muted-foreground/50 mt-2 font-mono" dir="ltr">
            {id}
          </p>
        </div>
        <Button onClick={handlePrint} className="w-full gradient-hero border-0">
          <Printer className="w-4 h-4 ml-2" />
          طباعة البطاقة
        </Button>
      </DialogContent>
    </Dialog>
  );
}
